import React from "react";
import { Tooltip, withStyles } from "@material-ui/core";

const StyledTooltip = withStyles({
    tooltip: {
        color: 'white',
        backgroundColor: 'grey',
        width: "200px",
        fontSize: "14px"
    }
})(Tooltip)

const PDFTooltip = ({children, title, ...props}:any) => {
    return (
        <StyledTooltip title={title} {...props}>
            <span>{children}</span>
        </StyledTooltip>
    )
}

export default PDFTooltip;